import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { AppUpdateService } from './app-update.service';

@Component({
  selector: 'app-update-dialog',
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
  templateUrl: './app-update-dialog.component.html',
  styleUrl: './app-update-dialog.component.css',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateDialogComponent implements OnInit {
  readonly updates = inject(AppUpdateService);

  ngOnInit(): void {
    this.updates.start();
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) this.updates.postpone();
  }
}
